define('views/modules/template/edit/calendar/calendar-component/template-item-delete-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/calendar/calendar-component/item/item-delete-modal',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VCalendarItemDeleteModal
) {

    var VTemplateCalendarItemDeleteModal = VCalendarItemDeleteModal.extend({
        ////////////
        // events //
        ////////////
        onConfirm: function(confirmed) {
            if (!confirmed) return;
            var model = this.model;
            if (this.isDeletingSession()) {
                model.trigger('session:destroy', model);
            } else {
                model.trigger('item:destroy', model);
            }
        }

    });

    return VTemplateCalendarItemDeleteModal;
});

